import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCompanyInfo } from '../../api/config';
import CanvasText from './CanvasText';
import { executeKakaoShare } from '../../utils/kakaoShare';

const Footer = () => {
    const [info, setInfo] = useState({
        name: '',
        representative: '',
        businessNumber: '',
        commerceNumber: '',
        address: '',
        phone: '',
        email: ''
    });

    useEffect(() => {
        const fetchInfo = async () => {
            try {
                const data = await getCompanyInfo();
                if (data) {
                    setInfo(prev => ({
                        ...prev,
                        ...data
                    }));
                }
            } catch (err) {
                console.error('Failed to load footer info', err);
            }
        };
        fetchInfo();
    }, []);

    // CanvasText 공통 스타일
    const textStyle = {
        marginLeft: '4px',
        marginRight: '4px'
    };

    return (
        <footer className="p-8 bg-surface-bg mt-8 text-sm text-gray-500 leading-relaxed border-t border-gray-200">
            <div className="mb-4 select-none">
                <p className="text-lg text-gray-900 mb-2 font-bold">
                    {info.name}
                </p>

                <div className="flex flex-wrap gap-y-1 items-center">
                    <span>책임자 : </span>
                    <CanvasText text={info.representative} style={textStyle} />
                    <span className="mx-2 text-gray-300">|</span>

                    <span>사업자등록번호 : </span>
                    <CanvasText text={info.businessNumber} style={textStyle} />
                    <span className="mx-2 text-gray-300">|</span>

                    <span>통신판매업신고번호 : </span>
                    <CanvasText text={info.commerceNumber} style={textStyle} />
                </div>

                <div className="flex flex-wrap gap-y-1 items-center">
                    <span>주소 : </span>
                    <CanvasText text={info.address} type="copy" style={textStyle} />
                </div>

                {/* Desktop Contact Text */}
                <div className="hidden md:flex flex-wrap gap-y-1 items-center mt-2">
                    <span>대표전화 : </span>
                    {info.phone && <CanvasText text={info.phone} type="tel" color="#666" style={textStyle} />}
                    <span className="mx-2 text-gray-300">|</span>

                    <span>대표메일 : </span>
                    {info.email && <CanvasText text={info.email} type="email" color="#666" style={textStyle} />}
                </div>

                {/* Mobile Contact Action Buttons */}
                <div className="flex md:hidden gap-3 mt-6 mb-4">
                    <button
                        onClick={() => info.phone && (window.location.href = `tel:${info.phone}`)}
                        className="flex-1 flex items-center justify-center gap-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 py-3.5 rounded-2xl font-bold transition-colors focus:outline-none group"
                    >
                        <div className="w-[36px] h-[36px] bg-green-500 rounded-full flex items-center justify-center shadow-sm group-hover:scale-105 transition-transform p-2">
                            <svg className="w-full h-full text-white" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.28-.28.67-.36 1.02-.25 1.12.37 2.32.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                            </svg>
                        </div>
                    </button>
                    <button
                        onClick={() => executeKakaoShare({})}
                        className="flex-1 flex items-center justify-center gap-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 py-3.5 rounded-2xl font-bold transition-colors focus:outline-none group"
                    >
                        <div className="w-[36px] h-[36px] bg-[#FEE500] rounded-full flex items-center justify-center shadow-sm group-hover:scale-105 transition-transform p-2">
                            <svg className="w-full h-full text-black" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M12 3C6.48 3 2 6.36 2 10.5C2 13.04 3.51 15.28 5.82 16.59L4.85 20.14C4.76 20.5 5.16 20.78 5.48 20.59L9.69 17.82C10.43 17.94 11.2 18 12 18C17.52 18 22 14.64 22 10.5C22 6.36 17.52 3 12 3Z"/>
                            </svg>
                        </div>
                    </button>
                    <button
                        onClick={() => info.email && (window.location.href = `mailto:${info.email}`)}
                        className="flex-1 flex items-center justify-center gap-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 py-3.5 rounded-2xl font-bold transition-colors focus:outline-none group"
                    >
                        <div className="w-[36px] h-[36px] bg-blue-500 rounded-full flex items-center justify-center shadow-sm group-hover:scale-105 transition-transform p-2">
                            <svg className="w-full h-full text-white" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                                <polyline points="22,6 12,13 2,6"></polyline>
                            </svg>
                        </div>
                    </button>
                </div>
            </div>

            <div className="pt-4 border-t border-gray-300 flex flex-wrap items-center">
                <Link to="/privacy" className="text-gray-500 hover:text-primary-500 transition-colors">개인정보처리방침</Link>
                <span className="mx-2 text-gray-300">|</span>
                <Link to="/terms" className="text-gray-500 hover:text-primary-500 transition-colors">이용약관</Link>
                
                <p className="w-full mt-2 text-xs text-gray-400">
                    © {new Date().getFullYear()} {info.name}. All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
